import { JourneyBadge } from '@usealloy/component-library';

import { truncate } from '~/helpers/formatting';
import OptionBadge from '~/queries/OptionBadge';

import type { Props as DropdownFacetProps } from './DropdownFacet';

type Props = {
  facet: DropdownFacetProps['facet'];
  textProps: any;
  value: string;
  wrapperProps: any;
};

export default function DetailedOptionLabel({
  facet,
  textProps,
  value,
  wrapperProps,
}: Props) {
  const option = facet.options.find(o => o.value === value);

  return (
    <span {...wrapperProps}>
      {option?.fa && (
        <OptionBadge
          facet={facet}
          option={option}
          value={value}
        />
      )}
      {facet.key === 'journeyApplicationStatus' && value !== 'all' && (
        <JourneyBadge
          outcome={value}
          {...(option?.icon_name && { outcomeIcon: option.icon_name })}
          {...(option?.outcome_color && {
            style: {
              backgroundColor: option.outcome_color,
              display: 'inline-flex',
            },
          })}
        />
      )}

      <span {...textProps}>
        {option ? truncate(option.label, 75) : facet.dropdown_label.label}
      </span>

      {option && option.extra && <span>{option.extra}</span>}
    </span>
  );
}
